// import { UNIFIED_PAYMENT } from '../mutationTypes'
import { postPaymentent } from '@/models/pay'
// const state = {
//     payInfo: {}
// }

const mutations = {
    // UNIFIED_PAYMENT (state, data) {
    //     state.payInfo = data
    // }
    // [UNIFIED_PAYMENT] (data, lng, lat) {
    //     state.payInfo = data.payInfo
    // }
}

export const actions = {
    // 统一下单接口
    async postUnifiedPayment ({ commit }, data) {
        return postPaymentent(data)
    }
}

export const getters = {}

export default {
    mutations
}
